import { connect } from 'react-redux';

import { createIdentities } from '../actions/LoginActions';
import { checkCredentials, clearInputError, setInputError } from '../actions/GenericActions';
import { generateCaptcha } from '../actions/captcha_actions';
import LoginView from '../components/Steps/Login/LoginView';

const mapStateToProps = state => ({
  captcha: state.captcha,
  login: state.identification.login,
  loginError: state.identification.loginError,
  isLoading: state.generic.request.isLoading,
});

const mapDispatchToProps = dispatch => ({
  generateCaptcha: () => dispatch(generateCaptcha()),
  checkCredentials: (field, value) => dispatch(checkCredentials(field, value)),
  createIdentities: ({ login, captcha }) => dispatch(createIdentities({ login, captcha })),
  clearInputError: ({ field }) => dispatch(clearInputError({ field })),
  setInputError: ({ field, error }) => dispatch(setInputError({ field, error })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginView);
